import sendPointOfNeedAppEvent from "../../components/AlmeApp/initialize/sendPointOfNeedAppEvent";
import { updateCurrentLaunchTypeCookieValue } from "../../components/AlmeLaunchPoint/LaunchTypeCookie";
import { getTenantByAccessKey, defaultTenant } from "../../components/AlmeTenantSelector/AlmeTenants";
import { updateCurrentHadLiveChatCookieValue } from "../../components/LiveChat/AlmeLiveChatSurvey/HadLiveChatQualtricsCookie";
import { MessageHandlerBase } from "./MessageHandlerBase";
export default class LaunchIvaHandler extends MessageHandlerBase {
    constructor(almeState, setAlmeState, appConfig, apiUtils, ivaSetChatStatus) {
        super(almeState, setAlmeState, appConfig, apiUtils);
        this.ivaSetChatStatus = ivaSetChatStatus;
    }
    handle(message) {
        const accessKey = message.accessKey && message.accessKey.trim();
        if (this.appConfig.setTenant && accessKey !== this.almeState.accessKey) {
            this.appConfig.setTenant(getTenantByAccessKey(accessKey) || defaultTenant);
        }
        const state = Object.assign(Object.assign({}, this.almeState), { accessKey: accessKey, launchParameter: message.launchParameter, launchPointName: message.launchPointName });
        if (this.almeState.isInitialAppEventsSent && message.launchParameter === "PointOfNeed" && !this.almeState.sessionExpired && !this.almeState.isLiveChatConnected) {
            this.onPointOfNeedAppEvent(state, message);
        }
        else if (!this.almeState.isOpen) {
            this.setAlmeState(Object.assign(Object.assign({}, state), { isOpen: true }));
            this.autoOpenIVAChatAndSetCookie(message);
        }
    }
    onPointOfNeedAppEvent(state, message) {
        sendPointOfNeedAppEvent(this.apiUtils, state)
            .then((pointOfNeedResponse) => {
            if (pointOfNeedResponse) {
                state.history.push(pointOfNeedResponse);
                if (!this.almeState.isOpen) {
                    state.isOpen = true;
                    this.autoOpenIVAChatAndSetCookie(message);
                }
                this.setAlmeState(Object.assign(Object.assign({}, state), { lastEntryId: pointOfNeedResponse.extensionData.entryId, chatId: pointOfNeedResponse.extensionData.chatId, launchPointName: undefined, launchParameter: undefined, lastActivityTime: Date.now() }));
            }
        })
            .catch((error) => console.log(error));
    }
    autoOpenIVAChatAndSetCookie(message) {
        let launchType;
        if (message.launchParameter === "ContactUs" || message.launchParameter === "secureMessaging") {
            launchType = "Proactive";
        }
        else if (message.launchParameter === "PointOfNeed") {
            if (message.launchPointName === "LoginError") {
                launchType = "Proactive";
            }
            else {
                launchType = "Reactive";
            }
        }
        else {
            launchType = "Reactive";
        }
        updateCurrentHadLiveChatCookieValue("false");
        updateCurrentLaunchTypeCookieValue(launchType);
        this.ivaSetChatStatus.openChat();
    }
}
